module.exports = __webpack_public_path__ + "img/1alB-w-wi.09b98cab.jpg";